<template>
  <div class='cirConfig'>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="queryConfig" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="queryConfig.serName" placeholder="输入设备名称" clearable @change='query'></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div :style="`height:${height}px`" class='setBgImg'>
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        <div class='setTabView' :style='`height:${height-50}px;width:${width-60}px`'>
          <div class='configList' :style='`height:${height-50}px`'>
            <el-table
              :data='serList'
              style="width:100%"
              border
              :max-height='height-105'
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              id="table">
              <el-table-column
                prop='serName'
                align='center'
                fixed
                min-width='100' 
                label="设备名称">
              </el-table-column>
              <el-table-column
                prop='serNo'
                align='center'
                min-width='50' 
                label="设备站号">
              </el-table-column>
              <el-table-column
                align='center' 
                label="温度上下限">
                <el-table-column
                  prop='tempInMax'
                  align='center'
                  min-width='90' 
                  label="仓内上限">
                </el-table-column>
                <el-table-column
                  prop='tempInMin'
                  align='center' 
                  min-width='90'
                  label="仓内下限">
                </el-table-column>
                <el-table-column
                  prop='tempOutMax'
                  align='center' 
                  min-width='90'
                  label="通风口上限">
                </el-table-column>
                <el-table-column
                  prop='tempOutMin'
                  align='center'
                  min-width='90' 
                  label="通风口下限">
                </el-table-column>
              </el-table-column>
              <el-table-column
                align='center' 
                label="仓内温湿度传感器地址">
                <el-table-column
                  :prop='`sensor${item}`'
                  align='center' 
                  :label="item+'号'"
                  :min-width='maxCNum<3?90:60'
                  v-for='item in maxCNum' :key='item'>
                </el-table-column>
              </el-table-column>
              <el-table-column
                align='center' 
                label="通风口温湿度传感器地址">
                <el-table-column
                  :prop='`ventsensor${item}`'
                  align='center' 
                  :label="item+'号'"
                  :min-width='maxTNum==1?160:(maxTNum==2?90:60)'
                  v-for='item in maxTNum' :key='item'>
                </el-table-column>
              </el-table-column>
              <el-table-column 
                prop="status" 
                label="通讯状态" 
                align='center'
                min-width="80">
                <template slot-scope="scope">
                  <span :class='scope.row.status==1?"onLine":"offLine"'>{{scope.row.status==1?"在线":"离线"}}</span>
                </template>
              </el-table-column>
              <el-table-column 
                label="操作" 
                min-width="200" 
                fixed='right'
                align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="readConfig(serList[scope.$index].serId,serList[scope.$index].status)" type="text" size="small">读取配置</el-button>
                  <el-button @click.native.prevent="getConfig(serList[scope.$index].nhlId,serList[scope.$index].status)" type="text" size="small">修改配置</el-button>
                  <el-button @click.native.prevent="setTask(serList[scope.$index].serId,serList[scope.$index].status)" type="text" size="small">定时任务</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total" 
            :pageSize='queryConfig.pageSize'
            :hide-on-single-page='true'
            :current-page='queryConfig.pageNum'
            @current-change='setCirConfigChange'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="`${configInfo.serName}配置信息`" :visible.sync="configView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg configInfoWrap"'>
      <div class='formWrap'>
        <el-form ref="configInfo" :model="configInfo" label-width="125px" class='configInfo' :rules='configRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>设备基本信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="设备站号" prop='serNo'>
              <el-input v-model="configInfo.serNo"></el-input>
            </el-form-item>
            <el-form-item label="仓内温度上限" prop='tempInMax'>
              <el-input v-model="configInfo.tempInMax"></el-input>
            </el-form-item>
            <el-form-item label="仓内温度下限" prop='tempInMin'>
              <el-input v-model="configInfo.tempInMin"></el-input>
            </el-form-item>
            <el-form-item label="通风口温度上限" prop='tempOutMax'>
              <el-input v-model="configInfo.tempOutMax"></el-input>
            </el-form-item>
            <el-form-item label="通风口温度下限" prop='tempOutMin'>
              <el-input v-model="configInfo.tempOutMin"></el-input>
            </el-form-item>
            <el-form-item label="仓内温湿度数量" prop='cNum'>
              <el-select v-model="configInfo.cNum" placeholder="选择仓内温湿度传感器数量">
                <el-option :label="item" :value='item' v-for='item in 5' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通风口温湿度数量" prop='tNum'>
              <el-select v-model="configInfo.tNum" placeholder="选择通风口温湿度传感器数量">
                <el-option :label="item" :value='item' v-for='item in 16' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="configInfo.cNum">
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>仓内温湿度传感器地址</div>
            <div class='dialog-setWrap'>
              <el-form-item :label="`${item}号传感器地址`" :prop='`sensor${item}`' v-for='item in configInfo.cNum' :key="item">
                <el-input v-model.number="configInfo['sensor'+item]"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if='configInfo.tNum'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>通风口温湿度传感器地址</div>
            <div class='dialog-setWrap'>
              <el-form-item :label="`${item}号传感器地址`" :prop='`ventsensor${item}`' v-for="item in configInfo.tNum" :key='item'>
                <el-input v-model.number="configInfo['ventsensor'+item]"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveConfig('configInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog 
      :title="`${taskInfo.serName}任务信息`" 
      :visible.sync="setTaskView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg taskInfoWrap"'>
      <div class='formWrap'>
        <el-form 
          ref='taskInfo' 
          :model='taskInfo'
          label-width="110px"
          :rules='taskRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>任务一信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="任务状态" style='width:100%;margin-bottom: 10px'>
              <el-switch
                v-model="taskInfo.taskstatus1"
                active-value="1"
                inactive-value="0"
                >
              </el-switch>
            </el-form-item>
            <el-form-item label="定时开(时)" prop='taskonhour1'>
              <el-select v-model="taskInfo.taskonhour1" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时开(分)" prop='taskonminute1'>
              <el-select v-model="taskInfo.taskonminute1" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(时)" prop='taskoffhour1'>
              <el-select v-model="taskInfo.taskoffhour1" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(分)" prop='taskoffminute1'>
              <el-select v-model="taskInfo.taskoffminute1" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>任务二信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="任务状态" style='width:100%;margin-bottom: 10px' prop='taskstatus2'>
              <el-switch 
                active-value="1"
                inactive-value="0"
                v-model="taskInfo.taskstatus2">
              </el-switch>
            </el-form-item>
            <el-form-item label="定时开(时)" prop='taskonhour2'>
              <el-select v-model="taskInfo.taskonhour2" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时开(分)" prop='taskonminute2'>
              <el-select v-model="taskInfo.taskonminute2" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(时)" prop='taskoffhour2'>
              <el-select v-model="taskInfo.taskoffhour2" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(分)" prop='taskoffminute2'>
              <el-select v-model="taskInfo.taskoffminute2" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>任务三信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="任务状态" style='width:100%;margin-bottom: 10px' prop='taskstatus2'>
              <el-switch 
                active-value="1"
                inactive-value="0"
                v-model="taskInfo.taskstatus3">
              </el-switch>
            </el-form-item>
            <el-form-item label="定时开(时)" prop='taskonhour3'>
              <el-select v-model="taskInfo.taskonhour3" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时开(分)" prop='taskonminute3'>
              <el-select v-model="taskInfo.taskonminute3" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(时)" prop='taskoffhour3'>
              <el-select v-model="taskInfo.taskoffhour3" placeholder="请选择小时">
                <el-option :label="item-1" :value='item-1' v-for='item in 24' :key='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="定时关(分)" prop='taskoffminute3'>
              <el-select v-model="taskInfo.taskoffminute3" placeholder="请选择分钟">
                <el-option :label="item-1" :value='item-1' v-for='item in 60' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveTaskInfo('taskInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    const ruleNum=(rule,val,callback)=>{
      if(val<1){
        callback(new Error('请输入大于1的数字'))
      }else if(val>65535){
        callback(new Error('请输入小于65535的数字'))
      }else{
        callback()
      }
    }
    const ruleTemp=(rule,val,callback)=>{
      if(val<-45){
        callback(new Error('请输入大于-45的数字'))
      }else if(val>80){
        callback(new Error('请输入小于80的数字'))
      }else{
        callback()
      }
    }
    const compareTime=(rule,val,callback)=>{
      if(rule.field=="taskoffhour1"){
        if(this.taskInfo.taskonhour1>this.taskInfo.taskoffhour1){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }else if(rule.field=='taskoffminute1'){
        if(this.taskInfo.taskonhour1==this.taskInfo.taskoffhour1&&this.taskInfo.taskoffminute1<this.taskInfo.taskonminute1){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }else if(rule.field=="taskoffhour2"){
        if(this.taskInfo.taskonhour2>this.taskInfo.taskoffhour2){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }else if(rule.field=='taskoffminute2'){
        if(this.taskInfo.taskonhour2==this.taskInfo.taskoffhour2&&this.taskInfo.taskoffminute2<this.taskInfo.taskonminute2){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }else if(rule.field=="taskoffhour3"){
        if(this.taskInfo.taskonhour3>this.taskInfo.taskoffhour3){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }else if(rule.field=='taskoffminute3'){
        if(this.taskInfo.taskonhour3==this.taskInfo.taskoffhour3&&this.taskInfo.taskoffminute3<this.taskInfo.taskonminute3){
          callback(new Error("关闭时间要大于开始时间"))
        }else{
          callback()
        }
      }
    }
    return{
      queryConfig:{
        pageNum:1,
        pageSize:14,
        orderByColumn:'serId',
        isAsc:'desc',
        serName:''
      },
      serList:[],
      total:0,
      configView:false,
      setTaskView:false,
      configInfo:{},
      maxCNum:1,
      maxTNum:1,
      loading:false,
      loading2:false,
      taskInfo:{},
      configRules:{
        serNo:[{trigger:'blur',message:'设备站号不能为空',required:true}],
        tempInMax:[{trigger:'blur',validator:ruleTemp}],
        tempInMin:[{trigger:'blur',validator:ruleTemp}],
        tempOutMax:[{trigger:'blur',validator:ruleTemp}],
        tempOutMin:[{trigger:'blur',validator:ruleTemp}],
        sensor1:[{trigger:'blur',validator:ruleNum}],
        sensor2:[{trigger:'blur',validator:ruleNum}],
        sensor3:[{trigger:'blur',validator:ruleNum}],
        sensor4:[{trigger:'blur',validator:ruleNum}],
        sensor5:[{trigger:'blur',validator:ruleNum}],
        ventsensor1:[{trigger:'blur',validator:ruleNum}],
        ventsensor2:[{trigger:'blur',validator:ruleNum}],
        ventsensor3:[{trigger:'blur',validator:ruleNum}],
        ventsensor4:[{trigger:'blur',validator:ruleNum}],
        ventsensor5:[{trigger:'blur',validator:ruleNum}],
        ventsensor6:[{trigger:'blur',validator:ruleNum}],
        ventsensor7:[{trigger:'blur',validator:ruleNum}],
        ventsensor8:[{trigger:'blur',validator:ruleNum}],
        ventsensor9:[{trigger:'blur',validator:ruleNum}],
        ventsensor10:[{trigger:'blur',validator:ruleNum}],
        ventsensor11:[{trigger:'blur',validator:ruleNum}],
        ventsensor12:[{trigger:'blur',validator:ruleNum}],
        ventsensor13:[{trigger:'blur',validator:ruleNum}],
        ventsensor14:[{trigger:'blur',validator:ruleNum}],
        ventsensor15:[{trigger:'blur',validator:ruleNum}],
        ventsensor16:[{trigger:'blur',validator:ruleNum}]
      },
      taskRules:{
        taskoffhour1:[{trigger: ['blur','change'],validator:compareTime}],
        taskoffminute1:[{trigger: ['blur','change'],validator:compareTime}],
        taskoffhour2:[{trigger: ['blur','change'],validator:compareTime}],
        taskoffminute2:[{trigger: ['blur','change'],validator:compareTime}],
        taskoffhour3:[{trigger: ['blur','change'],validator:compareTime}],
        taskoffminute3:[{trigger: ['blur','change'],validator:compareTime}]
      }
    }
  },
  created(){
    this.getConfigList()
  },
  methods:{
    query(){
      this.queryConfig.pageNum=1;
      this.getConfigList();
    },
    getConfigList(){
      axios.get('/system/nhl/list',{params:this.queryConfig}).then(res=>{
        if(res){
          let max1=1,max2=1;
          for(let i=0;i<res.rows.length;i++){
            if(max1<res.rows[i].cNum){
              max1=res.rows[i].cNum
            }
            if(max2<res.rows[i].tNum){
              max2=res.rows[i].tNum
            }
          }
          this.maxCNum=max1;
          this.maxTNum=max2;
          this.serList=res.rows;
          this.total=res.total
        }
      })
    },
    setCirConfigChange(val){
      this.queryConfig.pageNum=val;
      this.queryConfig.serName='';
      this.getConfigList();
    },
    getConfig(nhlId,status){
      if(status==1){
        axios.get(`/system/nhl/${nhlId}`).then(res=>{
          if(res){
            this.configView=true;
            this.configInfo=res.data;
          }
        })
      }else{
        this.$message({
          message:'不能配置离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    readConfig(serId,status){
      if(status==1){
        this.setLoading('.configList')
        axios.post('/system/nhl/readAllConfig',{serId:serId}).then(res=>{
          this.loading.close();
          if(res){
            this.getConfigList();
            this.$message({
              type: 'success',
              message: '读取成功!',
              duration:1000
            });
          }
        })
      }else{
        this.$message({
          message:'不能读取离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    setTask(serId,status){
      if(status==1){
        axios.get(`/system/task/getTaskBySerId/${serId}`).then(res=>{
          if(res){
            this.setTaskView=true;
            this.taskInfo=res.data
          }
        })
      }else{
        this.$message({
          message:'不能设置离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    // 设置加载动画
    setLoading(className){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector(className)
      })
    },
    saveConfig(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.setLoading('.configInfoWrap');
          for(let i=0;i<5;i++){
            if(i+1>this.configInfo.cNum){
              this.configInfo['sensor'+(i+1)]=0
            }
          }
          for(let i=0;i<16;i++){
            if(i+1>this.configInfo.tNum){
              this.configInfo['ventsensor'+(i+1)]=0
            }
          }
          axios.put('/system/nhl/setupNhl',this.configInfo).then(res=>{
            this.loading.close();
            if(res){
              this.getConfigList();
              this.$message({
                type: 'success',
                message: '配置成功!',
                duration:1000
              });
              this.configView=false
            }
          })
        }else{
          return false
        }
      })
    },
    saveTaskInfo(obj){
      this.$refs[obj].validate(valid=>{
        if(valid){
          this.setLoading('.taskInfoWrap');
          axios.put('/system/task/setupNhlTask',this.taskInfo).then(res=>{
            this.loading.close();
            if(res){
              this.getConfigList();
              this.$message({
                type: 'success',
                message: '设置成功!',
                duration:1000
              });
              this.setTaskView=false
            }
          })
        }else{
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cirConfig{
  .configList{
    border: 1px solid #e4e7ed;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto
  }
  .onLine{color: #3BD14A}
  .offLine{color: #AFAFAF}
}
  
</style>
